import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { useParams, useNavigate } from "react-router-dom";
import { INVENTORY } from "../../constants/route-paths";
import { getPOList } from "../../actions/project-management.action";
import { roundValue } from "../../util/decimal-utils";
import _ from "lodash";
import Breadcrumb from 'react-bootstrap/Breadcrumb';
import Table from 'react-bootstrap/Table';

const POStock = () => {
  const [itemId, setItemId] = useState("");
  const [poList, setPoList] = useState([]);

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const params = useParams();

  useEffect(() => {
    const id = params.itemId;
    setItemId(id);
    fetchPOList(id);
  }, [params.itemId]);

  const fetchPOList = (currentItemId) => {
    dispatch(getPOList({})).then(({ list: poList }) => {
      const POs = [];
      Array.isArray(poList) &&
        poList.forEach((po) => {
          const data = {};
          let totalAmount = 0;
          let totalQty = 0;
          Array.isArray(po.items) &&
            po.items.forEach((item) => {
              if (item.id === currentItemId) {
                totalAmount +=
                  parseFloat(item.qty || 0) * parseFloat(item.cost || 0);
                totalQty += parseFloat(item.qty || 0);
                data.poId = po.id;
                data.allocatedQty =
                  parseFloat(data.allocatedQty || 0) +
                  parseFloat(item.allocatedQty || 0);
                data.receivedQty =
                  parseFloat(data.receivedQty || 0) +
                  parseFloat(item.receivedQty || 0);
              }
            });

          if (!_.isEmpty(data)) {
            data.itemCost = parseFloat(totalAmount / totalQty);
            POs.push(data);
          }
        });
      setPoList(POs);
    });
  };

  const cancelHandler = () => {
    navigate(`/${INVENTORY}`);
  };

  return (
    <div className="purchase-order-block" data-cy="po-stock">

      <h2 className="content-heading text-uppercase" data-cy="heading">View PO Stock</h2>
      <div className="col-12 breadcrumb-block p-0" data-cy="breadcrumb">
        <Breadcrumb>
          <Breadcrumb.Item onClick={cancelHandler} data-cy="breadcrumb-inventory">INVENTORY </Breadcrumb.Item>
          <Breadcrumb.Item active data-cy="breadcrumb-view-po-stock"> View PO Stock</Breadcrumb.Item>
        </Breadcrumb>
      </div>

      <div className="material-list-block mt-3" data-cy="material-list">
        <div className="table-responsive">
          <Table bordered className="table-create table-material table-material-ch w-100-lg">
            <thead>
              <tr>
                <th className="w-auto" data-cy="po">PO</th>
                <th className="w-auto" data-cy="submitted-quote">Submitted Quote</th>
                <th data-cy="received-qty">Received Qty</th>
                <th data-cy="allocated-qty">Allocated Qty</th>
                <th data-cy="stock">Stock</th>
              </tr>
            </thead>
            <tbody data-cy="material-list-body">
              {poList.map((po, subtaskindex) => (
                <tr key={subtaskindex} data-cy="material-list-item">
                  <td data-cy="po">{po.poId}</td>
                  <td data-cy="submitted-quote">{roundValue(po.itemCost)}</td>
                  <td data-cy="received-qty">{roundValue(po.receivedQty)}</td>
                  <td data-cy="allocated-qty">{roundValue(po.allocatedQty)}</td>
                  <td data-cy="stock">{roundValue(po.receivedQty - po.allocatedQty)}</td>
                </tr>
              ))}
            </tbody>
          </Table>
        </div>
      </div>
    </div>
  );
};

export default POStock;
